import { Component } from "aframe";
import { AnchorEntity } from "../anchor";
import { AvatarActionInstance, AvatarComponent, AvatarEntity } from "../avatar";
import { AnimationActionInstance } from "../animation/animation-action";
import { InputActionDetail } from "../input/common";
import { SlotEntity } from "../slot";
import { InteractiveComponent } from "./button-and-trigger";
import { InteractiveEntity } from "./interaction";
import { AvatarInteractionTarget } from "./interaction-target";


export interface InteractionEventDetail
{
	avatar : AvatarEntity;
	interactor : SlotEntity; //The "hand" that did the interaction
	component : Component; //The button/trigger component that did the interaction
	input : InputActionDetail; //The input action that activated the interaction
	target? : SlotEntity | InteractiveEntity; //The thing we're interacting with
	anchor? : AnchorEntity; //If there's something in the interactor Slot, this is the Anchor that fits target Slot
}



export class EventEmitterAction implements AvatarActionInstance
{
	input? : InputActionDetail;
	animation? : AnimationActionInstance;
	emitter : InteractiveComponent;
	detail : InteractionEventDetail;
	
	constructor(avatar : AvatarComponent, input : InputActionDetail, target : AvatarInteractionTarget, emitter : InteractiveComponent )
	{
		//Get the info
		this.emitter = emitter;
		this.detail = 
		{
			avatar : avatar.el,
			interactor : target.slot!,
			component : emitter,
			input,
			target : target.currentTarget,
			anchor : target.currentAnchor
		};

		const activated = () => {
			input.feedback(1.0);
			emitter.el.dispatchEvent( new CustomEvent(emitter.data.event, { detail : this.detail, bubbles : emitter.data.bubbles } ) );
		};

		const scene = avatar.el.sceneEl!;
		if(scene.is("vr-mode"))
		{
			this.input = input;
			activated();
		}
		else if(!scene.is("ui-mode"))
		{
			target.locked = true;
			const animationTarget = target.slotItem  ?
				target.currentTarget : //Use item in hand with possible target
				target.currentAnchor || target.currentTarget
			this.animation = new AnimationActionInstance(avatar, input, emitter.data.animation, target.slot!, animationTarget || emitter.el);
			this.animation.finished.then( (completed) =>
			{
				target.locked = false;
				if(completed)
					activated();
			});
		}
		else
			activated();
	}

	tick(avatar: AvatarComponent, t: number, dt: number, wasGrounded: boolean): boolean | undefined | null {
		if(this.animation) return this.animation.tick(avatar, t, dt);
		if(this.input) return this.input.amount > 0;
	}

	destroy(avatar: AvatarComponent): void {
		if(this.animation)
			this.animation.destroy(avatar);
		
		if(this.emitter.data.endEvent)
			this.emitter.el.dispatchEvent(new CustomEvent(this.emitter.data.endEvent, { detail : this.detail, bubbles : this.emitter.data.bubbles } ) );
	}
	
}

